<template>
  <div class="settings-panel">
    <v-btn
      v-if="authData.accessLevel > 2"
      :active="authData.nextUiEnabled"
      class="text-textLighter opacity-50"
      variant="flat"
      :width="40"
      :min-width="40"
      height="40"
      title="Next UI"
      @click="toggleNextUi"
    >
      [N]
    </v-btn>

    <v-btn
      ref="whatsNew"
      variant="flat"
      :width="40"
      :min-width="40"
      height="40"
      data-beacon-article-sidebar="67351309734eb350c5fdb09b"
      @click.stop="$emit('tracking-event', {
        action: 'navLinkClick',
        args: { label: 'What\'s New' },
      })"
    >
      <DpplSvg
        file-name="platform/notification"
        @click="handleSvgClick"
      />
    </v-btn>
    <GetHelpButton
      :get-help-links="getHelpLinks"
    />
    <AccountDropdown
      v-bind="$attrs"
      :settings-nav-links="settingsNavLinks"
    />
  </div>
</template>

<script>
import GetHelpButton from '@/components/shared/GetHelpButton.vue';
import AccountDropdown from '@/components/shared/AccountDropdown.vue';
import DpplSvg from '@/components/datapeople/DpplSvg.vue';
import { useAppAuthData } from '@/stores/app/authData';
import { mapState } from 'pinia';

export default {
  name: 'SettingsPanel',
  components: {
    DpplSvg,
    GetHelpButton,
    AccountDropdown,
  },
  props: {
    getHelpLinks: { type: Array, default: () => [] },
    settingsNavLinks: { type: Array, default: () => [] },
  },
  emits: ['tracking-event'],
  computed: {
    ...mapState(useAppAuthData, ['authData']),
  },
  methods: {
    // We have to manually click the button when the svg is clicked to trigger the beacon event
    handleSvgClick() {
      this.$refs.whatsNew.$el.click();
    },
    toggleNextUi() {
      useAppAuthData().toggleNextUi();
    },
  },
};
</script>

<style scoped lang="less">
.settings-panel {
  display: flex;
    & > *:not(:first-child) {
      margin-left: 8px;
    }
  .v-btn {
    font-size: 12px !important;
    font-weight: 300 !important;
    border: none;
    .v-btn:before {
      opacity: 0 !important;
    }
    .v-ripple__container {
      opacity: 0 !important;
    }
    &:hover {
      background-color: fade(@bg-brand-default, 5%);
      color: @text-brand;
    }
  }
}
</style>
